import { z } from 'zod';
import { CbaPackageForm } from '@pages/Cba';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/cba/')({
  component: CbaPackageForm,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
